<template>
    <div class="main-queue">
        <div class="main-con-up" v-for="(file, index) in uploads" :key="index">
            <div class="container">
                <div class="relative">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="40" viewBox="0 0 32 40" fill="none">
                        <path
                            d="M0.75 4C0.75 2.20508 2.20508 0.75 4 0.75H20C20.1212 0.75 20.2375 0.798159 20.3232 0.883885L31.1161 11.6768C31.2018 11.7625 31.25 11.8788 31.25 12V36C31.25 37.7949 29.7949 39.25 28 39.25H4C2.20507 39.25 0.75 37.7949 0.75 36V4Z"
                            fill="white"
                            stroke="#D5D7DA"
                            stroke-width="1.5"
                        />
                        <path d="M20 0.5V8C20 10.2091 21.7909 12 24 12H31.5" stroke="#D5D7DA" stroke-width="1.5" />
                    </svg>
                    <div
                        class="file-badge"
                        :class="{
                            'bg-[#D92D20]': getExtension(file.name) === 'pdf' || getExtension(file.name) === 'png',
                            'bg-[#155EEF]': ['jpg', 'jpeg'].includes(getExtension(file.name)) || 
                                (!['pdf', 'jpeg', 'jpg'].includes(getExtension(file.name)) && getExtension(file.name) !== ''),
                        }"
                    >
                        {{ getExtension(file.name) }}
                    </div>
                </div>
                <div class="details-con">
                    <div class="file-details">
                        <div class="file-name">
                            <span>{{ file.name }}</span>
                            <svg
                                @click="removeFile(index)"
                                class="cursor-pointer"
                                v-if="file.progress !== 100"
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                            >
                                <path
                                    d="M10.6667 3.99998V3.46665C10.6667 2.71991 10.6667 2.34654 10.5213 2.06133C10.3935 1.81044 10.1895 1.60647 9.93865 1.47864C9.65344 1.33331 9.28007 1.33331 8.53333 1.33331H7.46667C6.71993 1.33331 6.34656 1.33331 6.06135 1.47864C5.81046 1.60647 5.60649 1.81044 5.47866 2.06133C5.33333 2.34654 5.33333 2.71991 5.33333 3.46665V3.99998M6.66667 7.66665V11M9.33333 7.66665V11M2 3.99998H14M12.6667 3.99998V11.4666C12.6667 12.5868 12.6667 13.1468 12.4487 13.5746C12.2569 13.951 11.951 14.2569 11.5746 14.4487C11.1468 14.6666 10.5868 14.6666 9.46667 14.6666H6.53333C5.41323 14.6666 4.85318 14.6666 4.42535 14.4487C4.04903 14.2569 3.74307 13.951 3.55132 13.5746C3.33333 13.1468 3.33333 12.5868 3.33333 11.4666V3.99998"
                                    stroke="#A4A7AE"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </div>
                        <p>{{ file.size }}</p>
                    </div>
                    <div class="progress-con">
                        <div class="progress-bar-con">
                            <div class="bar" :style="{ width: file.progress + '%' }"></div>
                        </div>
                        <p>{{ file.progress }}%</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
const props = defineProps({
    uploads: {
        type: Array as PropType<{ name: string; size: string; progress: number }[]>,
        required: true,
    },
});

const emit = defineEmits(['delete']);

const removeFile = (index: number) => {
    emit('delete', index);
};

const getExtension = (filename: string) => {
    const parts = filename.split('.');
    return parts.length > 1 ? parts.pop()?.toLowerCase() || '' : '';
};
</script>
<style lang="scss" scoped>
// @TODO miguel color #155eef not available in figma
.main-queue {
    @apply flex flex-col items-start gap-[12px] self-stretch;
}
.main-con-up {
    @apply flex p-4 items-start gap-1 self-stretch rounded-[12px] border border-gray-200 bg-white;

    .container {
        @apply flex items-start gap-[12px] flex-[1_0_0];

        .details-con {
            @apply flex flex-col items-start gap-1 flex-[1_0_0];

            .file-details {
                @apply flex flex-col items-start gap-1 flex-[1_0_0] w-full;

                p {
                    @apply overflow-hidden text-gray-600 text-ellipsis font-inter text-[14px] not-italic;
                    @apply font-normal leading-[20px];
                }

                .file-name {
                    @apply flex flex-row justify-between self-stretch;

                    span {
                        @apply max-w-[330px] overflow-hidden text-gray-700 text-ellipsis whitespace-nowrap;
                        @apply font-inter text-[14px] not-italic font-medium leading-[20px];
                    }

                    .icon-holder {
                        @apply flex w-[16px] h-[16px] p-[2px] cursor-pointer justify-center items-center;
                        @apply rounded-[4px] border border-[#155eef] bg-[#155eef];
                    }
                }
            }

            .progress-con {
                @apply flex items-center gap-[12px] self-stretch;

                .progress-bar-con {
                    @apply w-full h-2 bg-gray-200 rounded-full;

                    .bar {
                        @apply h-full rounded-full w-full bg-[#155eef];
                    }
                }

                p {
                    @apply text-gray-700 font-inter text-[14px] not-italic font-medium leading-[20px];
                }
            }
        }
    }
}
.file-badge {
    @apply uppercase absolute bottom-2 right-3 text-white text-center font-inter text-[10px] font-bold not-italic;
    @apply inline-flex p-[2px_3px] items-start gap-[8px] rounded-[2px] leading-none;
}
</style>
